import {AbstractControl} from '@angular/forms/src/model';
import Messages from './html-validate-display-messages';

export class HtmlValidateDisplayHelper {

    public hasErrors(control: AbstractControl, falseIfNotTouched: boolean = true): boolean
    {
        if(falseIfNotTouched && ! control.touched)
            return false;

        return control.errors ? true : false;
    }

    public display(control: AbstractControl, _default?: string): string
    {
        let html = [];

        if (control.errors == null && _default)
            return _default;

        Object.keys(control.errors).forEach(key => {

            if (Messages[key])
            {
                html.push(Messages[key](control));
            }
            else
                console.error('HTML-Validate-Display não tem um metodo para exibir a mensagem validação: ' + key);
        });

        return html.length ? html.join('<br/>') : null;
    }
}

